var _title, _desc, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgVipes = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "sluostes")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uzsakymai",
    transform: "translate(-1313.000000, -177.000000)",
    fill: "#464648",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sluostes",
    transform: "translate(1313.000000, 177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9270161,0 L1.19467742,0 C0.536008065,0 0,0.534919355 0,1.1921371 L0,10.8921774 C0,11.5493952 0.536008065,12.0835887 1.19467742,12.0835887 L10.9270161,12.0835887 C11.5853226,12.0835887 12.1213306,11.5490323 12.1213306,10.8921774 L12.1213306,1.1921371 C12.1213306,0.534919355 11.5856855,0 10.9270161,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9441129,7.8525 C17.8483065,7.54766129 17.64,7.29870968 17.3572984,7.15137097 L13.4281452,5.1078629 L13.4281452,11.4728226 C13.4281452,12.5299597 12.5666129,13.3900403 11.5080242,13.3900403 L3.14782258,13.3900403 L11.7508065,17.8642742 C11.9268145,17.9564516 12.1155242,18 12.3016935,18 C12.7328226,18 13.1490726,17.7666532 13.3617339,17.3602016 L17.8642742,8.75975806 C18.01125,8.47887097 18.0395565,8.1566129 17.9441129,7.8525 Z",
    id: "Path"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVipes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vipes.af7ab39b.svg";
export { ForwardRef as ReactComponent };